import React, { createContext, useContext, useState, useEffect } from 'react';
import { signOut as signOutCognito, signIn as signInCognito, fetchUserAttributes, fetchAuthSession } from '@aws-amplify/auth';
/*
interface User {
  email: string;
  name: string;
}*/
export interface User {
    "cognito:groups": string[];  // 🔹 Grupos del usuario en Cognito
    "custom:RUT": string;        // 🔹 Identificación personalizada
    name: string;                // 🔹 Nombre del usuario
    email: string;               // 🔹 Correo electrónico
    token?: string;              // 🔹 (Nuevo) Token de autenticación opcional
}

interface AuthContextType {
    user: User | null;
    login: (email: string, password: string) => Promise<string>;
    logout: () => void;
    isAuthenticated: boolean;
    isLoading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

interface AuthProviderProps {
    children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Verificar si hay una sesión guardada al iniciar
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
            setUser(JSON.parse(savedUser));
        }
        setIsLoading(false);
    }, []);

    const login = async (email: string, password: string): Promise<string> => {
        //setIsLoading(true);

        // Simulamos una autenticación (en un caso real, aquí harías la llamada a tu API)
        try {
            const login = await signInCognito({ username: email, password });

            if (login.isSignedIn && login.nextStep.signInStep === 'DONE') {
                const userAttributes = await fetchUserAttributes();
                //const currentUser= await getCurrentUser();
                const session = await fetchAuthSession();
                const token = session.tokens?.idToken; // Obtener token de sesión desde Cognito
                const groups: string[] = session.tokens?.accessToken.payload["cognito:groups"]
                    ? (Array.isArray(session.tokens?.accessToken.payload["cognito:groups"])
                        ? session.tokens?.accessToken.payload["cognito:groups"] as string[]
                        : [session.tokens?.accessToken.payload["cognito:groups"].toString()])
                    : [];
                console.log(JSON.stringify("groups:" + groups));
                const userSession: User = {
                    "cognito:groups": groups,
                    "custom:RUT": userAttributes["custom:rut"] || "N/A", // Ajustar según atributos personalizados
                    name: userAttributes.name ? userAttributes.name : email,
                    email: userAttributes.email ? userAttributes.email : email,
                    //token: token?.toString()
                };
                
                // Guardar sesión en localStorage
                localStorage.setItem('user', JSON.stringify(userSession));
                // Actualizar estados locales y globales
                setUser(userSession);
            }
            return login.nextStep.signInStep;
        } catch (error) {
            console.error('Error al iniciar sesión:', error);
            signOutCognito();
            if ((error + '').startsWith("NotAuthorizedException")) {
                return 'BAD_CREDENTIALS';
            }
            return 'ERROR';
        }finally{
             //setIsLoading(false);
        }
    };

    const logout = () => {
        signOutCognito();
        setUser(null);
        localStorage.removeItem('user');

    };

    const value = {
        user,
        login,
        logout,
        isAuthenticated: !!user,
        isLoading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
